// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SideWidgetKeyDates_wrapper","module":"SideWidgetKeyDates_module","content":"SideWidgetKeyDates_content"};